// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"936":"53d71bf354cf04da","1221":"2f8daefc5b589185","3602":"d8f024f734335ea6","4937":"eab886131b422850"}[chunkId] + ".css";
};